<script>
  import GoogleAdSense from "$components/adSense/googleAdSense.svelte";
  import Question from "$components/common/Question.svelte";
  import { t } from "$lib/i18n/translations";
  import { base } from "$app/paths";

  const cardList = [
    {
      title: "about.features.fast_downloads.title",
      description: "about.features.fast_downloads.description",
      image: `${base}/icons/about-fastdownload-icon.png`,
    },
    {
      title: "about.features.works_on_any_device.title",
      description: "about.features.works_on_any_device.description",
      image: `${base}/icons/about-anydevice-icon.png`,
    },
    {
      title: "about.features.privacy_security.title",
      description: "about.features.privacy_security.description",
      image: `${base}/icons/about-privacy-icon.png`,
    },
  ];
</script>

<div class="pt-[72px] max-mobile:pt-[56px]">
  <div class="w-full mb-[110px] max-mobile:mb-0">
    <div class="max-w-[1100px] mx-auto mt-[48px] mb-[150px] relative max-mobile:mb-[40px] max-mobile:mt-0"> 
      <!-- About InstaTube 部分 -->
      <div
        class="mb-[120px] px-[40px] py-[50px] bg-[#F2F7FF] rounded-[16px] max-mobile:px-[20px] max-mobile:py-[32px] max-mobile:mb-[40px] max-mobile:rounded-none"
      >
        <p
          class="text-[48px] font-bold mb-6 text-center mt-2 max-mobile:text-[24px] max-mobile:mb-4"
        >
          {$t("about.title")}
        </p>
        <div class="text-[20px] max-mobile:text-[14px]">
          <p class="mb-6 max-mobile:mb-4">{$t("about.description")}</p>
          <p class="mb-6 max-mobile:mb-4">{$t("about.disclaimer")}</p>
          <p class="">{$t("about.service_info")}</p>
        </div>
      </div>
      <!-- WHY CHOOSE InstaTube 部分 -->
      <div class="flex items-center relative z-1 max-mobile:flex-col">
        <div
          class="grow-1 max-mobile:mb-[24px] max-mobile:text-center max-mobile:px-[16px]"
        >
          <p
            class="text-[48px] font-bold mb-[32px] leading-[1.5] mr-[41px] max-mobile:text-[20px] max-mobile:mr-0 max-mobile:mb-[12px]"
          >
            {$t("about.why_choose_title")}
          </p>
          <p
            class="text-[20px] leading-[2] mr-[82px] max-mobile:text-[14px] max-mobile:mr-0 max-mobile:text-[#808080]"
          >
            {$t("about.download_description")}
          </p>
        </div>
        <div
          class="w-[640px] shrink-0 bg-[#6782FB] rounded-[16px] py-[32px] flex flex-col gap-[32px]
          max-mobile:w-full max-mobile:py-[28px] max-mobile:px-[20px] max-mobile:rounded-none
          "
        >
          {#each cardList as card, i}
            <div
              class="bg-white rounded-[16px] px-[20px] py-[16px] flex w-[468px] {i ==
              0
                ? 'ml-[132px]'
                : i == 1
                  ? 'ml-[32px]'
                  : 'ml-[226px]'}
                  max-mobile:ml-0
                  max-mobile:w-full
                  max-mobile:py-[20px]
                  max-mobile:px-[16px]
                  max-mobile:items-center
                  "
            >
              <img
                src={card.image}
                alt={$t(card.title)}
                class="w-[64px] h-[64px]"
              />
              <div class="ml-[24px] max-mobile:ml-[16px]">
                <p
                  class="mb-[8px] font-bold text-[24px] leading-[1.25] max-mobile:text-[16px]"
                >
                  {$t(card.title)}
                </p>
                <p class="text-[18px] leading-[1.5] max-mobile:text-[14px]">
                  {$t(card.description)}
                </p>
              </div>
            </div>
          {/each}
        </div>
      </div>
      <div
        class="absolute bottom-[-46px] right-[-46px] z-0 bg-[#F84095] w-[240px] h-[240px] bg-[#fa9dcc] blur-[92px] rounded-full max-mobile:hidden"
      ></div>
    </div>
    <div class="max-w-[1280px] mx-auto">
      <GoogleAdSense type="crosswise"/>
    </div>
  </div>
</div>
<Question />
